let timeout: NodeJS.Timeout;

export const debounce = (callback: () => void, delay: number) => () => {
	clearTimeout(timeout);
	timeout = setTimeout(callback, delay);
};
